import React from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

export const Wrapper = ({ style, children, sx, id }) => (
  <Grid item sx={sx}>
    <Grid
      component='section'
      id={id}
      container
      xs={10}
      sm={9.8}
      md={9.8}
      xl={6}
      sx={{
        marginInline: 'auto',
        padding: '70px 0px',
        ...style,
      }}
    >
      {children}
    </Grid>
  </Grid>
);

Wrapper.propTypes = {
  children: PropTypes.element,
  style: PropTypes.objectOf(PropTypes.shape),
};
